import { apiRequest } from "../../lib/api-client";

export type VisitsByDayPoint = { date: string; count: number };
export type StatusBreakdownPoint = { status: string; count: number };
export type TopHostPoint = { host_name: string; visit_count: number };

export function getVisitsByDay(days = 14, signal?: AbortSignal) {
  return apiRequest<VisitsByDayPoint[]>(`/dashboard/charts/visits-by-day?days=${days}`, { signal });
}

export function getStatusBreakdown(signal?: AbortSignal) {
  return apiRequest<StatusBreakdownPoint[]>("/dashboard/charts/status-breakdown", { signal });
}

export function getTopHosts(limit = 5, signal?: AbortSignal) {
  return apiRequest<TopHostPoint[]>(`/dashboard/charts/top-hosts?limit=${limit}`, { signal });
}
